(function () {
  function initContactForm(root) {
    if (!root || root.dataset.contactReady === 'true') return;
    root.dataset.contactReady = 'true';

    var form = root.querySelector('form');
    var message = root.querySelector('[data-contact-message]');
    var counter = root.querySelector('[data-contact-counter]');
    var submit = root.querySelector('[data-contact-submit]');
    var topic = root.querySelector('[data-contact-topic]');
    var orderWrap = root.querySelector('[data-order-field]');

    function updateCounter() {
      if (!message || !counter) return;
      counter.textContent = String(message.value.length) + '/2000';
    }

    function updateOrderVisibility() {
      if (!topic || !orderWrap) return;
      var shouldShow = topic.value === 'Pedido existente' || topic.value === 'Envíos y devoluciones';
      orderWrap.hidden = !shouldShow;
    }

    if (message) {
      message.addEventListener('input', updateCounter);
      updateCounter();
    }

    if (topic) {
      topic.addEventListener('change', updateOrderVisibility);
      updateOrderVisibility();
    }

    if (form && submit) {
      form.addEventListener('submit', function () {
        if (!form.checkValidity()) return;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        var label = submit.querySelector('[data-submit-label]');
        if (label) label.textContent = 'Enviando…';
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-minima-contact]').forEach(initContactForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
